module.exports = __webpack_public_path__ + "static/Book-8b33d754a247cdc1831130c256db8a67.png";